import ArabicSection from "@components/ArabicSection";
import ArabicTestimonialSection from "@components/ArabicTestimonialSection";
import ArabicVideoSection from "@components/ArabicVideoSection";
import ClientLogosArabic from "@components/ClientLogosArabic";
import CtaButton from "@components/CtaButton";
import GallaboxBadgesGray from "@components/GallaboxBadgesGray";
import ImageGrid from "@components/ImageGrid";
import Modal from "@components/Modal/Modal";
import NewLayout from "@components/new-ui/Layout";
import YellowCTAhref from "@components/yellowCTAhref";
import "keen-slider/keen-slider.min.css";
import Head from "next/head";
import Script from "next/script";
import React, { FC, useEffect } from "react";

const Home: FC = () => {
    const [modalHeader, setModalHeader] = React.useState<string | null>(null);

    const [isMobile, setIsMobile] = React.useState<boolean>(false);
    const [Addclassforvideo, setAddclassforvideo] = React.useState<boolean>(false);

    const handleClose = () => {
        setModalHeader(null);
    };

    useEffect(() => {
        const width = screen.width;
        if (width < 750) setIsMobile(true);
        setInterval(function () {
            const show = document.querySelector("span[data-show]");
            const next = show?.nextElementSibling || document.querySelector(".first-ch");
            const up = document.querySelector("span[data-up]");

            if (up) {
                up.removeAttribute("data-up");
            }

            show?.removeAttribute("data-show");
            show?.setAttribute("data-up", "");

            next?.setAttribute("data-show", "");
        }, 2000);
    }, []);

    return (
        <NewLayout
            keywords="برمجيات دعم العملاء متعددة القنوات، واجهة برمجة واتساب للأعمال، روبوت محادثة واتساب، صندوق وارد مشترك في واتساب، إدارة نجاح العملاء، إدارة العملاء المحتملين."
            title="جالابوكس | التَّلقائية لواتساب للأعمال والروبوتات في المحادثات عبر واتساب"
            description="جالابوكس هو مساحة عمل بدون كود يُمكن من استخدام قوة واتساب لتوسيع نطاق عملك من خلال صندوق وارد مشترك، روبوت محادثات واتساب بدون كود، بث رسائل واتساب والمزيد."
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/ar/Home-og.png" }}
            withLiveChat
            canonical="https://gallabox.com/ar"
            isFreezone
            isArabic
        >
            <Script src="https://fast.wistia.com/embed/medias/730lmkyzty.jsonp" async />
            <Script src="https://fast.wistia.com/assets/external/E-v1.js" async />
            <Head>
                <link rel="alternate" hrefLang="en" href="https://gallabox.com/" />
                <link rel="alternate" hrefLang="en-us" href="https://gallabox.com/us" />
                <link rel="alternate" hrefLang="ar" href="https://gallabox.com/ar" />
                <link rel="alternate" hrefLang="x-default" href="https://gallabox.com/" />
            </Head>

            <section className="relative app-home pt-[68px] bg-white" style={{ zIndex: 0 }}>
                <header className="relative mx-auto md:mt-16 " style={{ width: "100%", maxWidth: "1600px" }}>
                    <div className="absolute home-brown"></div>
                    <div className="absolute home-white"></div>
                    <div className="absolute home-blue"></div>
                    <div style={{ paddingTop: 50 }}>
                        <div className="flex lg:flex-row flex-col lg:max-w-2xl  max-w-6xl  mx-auto">
                            <div
                                className="text-green-700 bg-green-200 wati-top-green font-bold flex flex-nowrap lg:mx-0 mx-auto relative"
                                style={{ padding: "5px 12px", borderRadius: "50px", border: "0.5px solid #AAF0C4" }}
                            >
                                <p className=" pr-2" style={{ color: "#087443" }}>
                                    مدعوم من واجهة برمجة تطبيقات واتساب للأعمال الرسمية
                                </p>
                                <span className="wa-control-img">
                                    <img
                                        height={"24px"}
                                        width={"24px"}
                                        src="https://assets.gallabox.com/gb-home/new-zapier/wa-w-whiteborder.svg"
                                        className="ml-2"
                                        style={{ margin: 0 }}
                                        alt="white-border-whatsapp-icon"
                                    />
                                </span>
                            </div>
                            <img className="z-1 lg:mx-0 mx-auto" src="/nav-icons/meta-head.svg" style={{ height: "30px" }} alt="" />
                        </div>

                        <h3 className="head-title mx-auto text-center md:w-4/5 mt-5 md:mt-0 relative " style={{ marginBottom: "13px" }}>
                            <span>
                                حوّل محادثات عملائك إلى
                                <span>
                                    <span className="hidden md:inline">
                                        <div className="inline-block sm-white-blk"></div>
                                        <img className="header-leaf" src="https://assets.gallabox.com/gb-home/home/yellow-drops.svg" alt="" />
                                    </span>
                                </span>
                            </span>
                            <span className="block">
                                <span className=" text-blue-500">عملاء محتملين</span>
                            </span>
                        </h3>
                        <p className="z-2 relative sub-head text-center md:w-5/12 mx-auto">
                            أطلق العنان لقوة الروبوتات من خلال سهولة إرسال الرسائل <br /> لزيادة المبيعات وإسعاد العملاء.
                        </p>
                    </div>
                    <div className="relative  home-hero-image-container pt-24 lg:pb-8">
                        <div className="absolute mx-auto md:inset-x-1/4 top-0 md:-top-8 home-button">
                            <div className="w-fit mx-auto py-4">
                                <CtaButton type="large" text={" سجل مجانًا"} />
                            </div>
                            <div className="flex mt-2 items-center gap-4 mx-auto w-fit">
                                {["لا توجد رسوم الإعداد.", "سهل الاستخدام."].map((each) => {
                                    return (
                                        <div className="flex items-center gap-1 md:gap-2" key={each}>
                                            <p className="head-points text-gray-700">{each}</p>
                                            <img src="https://assets.gallabox.com/gb-home/content-with-image/green-tick-circle.svg" alt="Green Checkmark" className="" />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="relative">
                            {isMobile ? (
                                <img src="https://assets.gallabox.com/gb-home/home/home-page-phone.png" alt="" className="phone-pic relative top-26" />
                            ) : (
                                <img src="https://assets.gallabox.com/gb-home/home-header-new.png" alt="" className="mx-auto relative top-20" />
                            )}
                        </div>
                    </div>
                    <img src="https://assets.gallabox.com/gb-home/gif/Conversation.gif" alt="conversation gif" className="absolute msg-gif  top-72 left-64  hidden md:inline" />
                    <img
                        style={{ top: "415px", right: "65px" }}
                        src="https://assets.gallabox.com/gb-home/gif/text-msg.gif"
                        alt="msg gif"
                        className="absolute msg-gif invisible  md:visible"
                    />
                </header>

                <section className="client-logos pt-2 md:pt-0 lg:px-44">
                    <ClientLogosArabic />
                </section>
                <ArabicVideoSection botIconSrc="https://assets.gallabox.com/gb-home/ai/herosection-mp4.mp4" />
                <ArabicSection
                    heading="روبوتات بدون تعليمات برمجية لأتمتة محادثات عملائك على الواتساب"
                    point1="النشر على الفور من مكتبة قوالب الروبوت المعدة مسبقًا عبر حالات الاستخدام المتعددة"
                    point2="تخصيص تدفق روبوت الدردشة عندما تريد دون أي مساعدة فنيةتخصيص تدفق روبوت الدردشة عندما تريد دون أي مساعدة فنية"
                    point3="التكامل بسلاسة مع نظام إدارة علاقات العملاء الخاص بك وتطبيقات الأعمال الهامة الأخرى"
                    botIconSrc="https://assets.gallabox.com/gb-home/client-logos-arabic/section1.png"
                />
                <ArabicSection
                    isImageRightSide
                    heading="البريد الوارد للفريق المشترك يجعل التعاون بين الفريق أمرًا سهلاً للغاية"
                    point1="احصل على سياق في الوقت الفعلي وعرض 360 درجة لجميع محادثات العملاء"
                    point2="السماح للوكلاء بمشاركة التحديثات المباشرة والتعاون بشكل أفضل من خلال الإشارات والملاحظات"
                    point3="قل وداعًا لمنحنيات التعلم الطويلة من خلال واجهة بديهية تشبه واجهة واتساب"
                    botIconSrc="https://assets.gallabox.com/gb-home/client-logos-arabic/section2.png"
                />
                <ArabicSection
                    heading="حملات بث مخصصة لخط أنابيب مبيعات قوي"
                    point1="إنشاء شرائح العملاء على أساس السمات والسلوك الماضي"
                    point2="أضف عناصر تفاعلية ووسائط غنية لإنشاء رسائل جذابة"
                    point3="احصل على تحليلات قابلة للتنفيذ للحملة مثل المقاييس المرسلة والمسلمة والقراءة والرد"
                    botIconSrc="https://assets.gallabox.com/gb-home/client-logos-arabic/section3.png"
                />
                <ArabicSection
                    isImageRightSide
                    heading="قم بدمج كتالوج المنتجات الخاصة بك وبيعها من خلال واتساب"
                    point1="اعرض كتالوج المنتجات الخاصة بك وشاركه مع العملاء على واتساب"
                    point2="إرسال تأكيد الطلب وتحديثات الفواتير من خلال رسائل الواتساب"
                    point3="تحويل واتساب الأعمال إلى قناة المبيعات الأكثر فعالية لديك"
                    botIconSrc="https://assets.gallabox.com/gb-home/client-logos-arabic/section4.png"
                />
                <ArabicSection
                    heading="إنشاء وإرسال تسلسل تلقائي لرسائل واتساب"
                    point1="إرسال سلسلة من الرسائل إلى جهات الاتصال الخاصة بك على مدى فترة بترتيب محدد سلفًا"
                    point2="قم بزيادة مشاركة عملائك دون عناء باستخدام حملات واتساب بالتقطير"
                    point3="إلحاق العملاء، وإرسال رسائل تذكير بالدفع، ومشاركة تحديثات إطلاق المنتج، والمزيد"
                    botIconSrc="https://assets.gallabox.com/gb-home/client-logos-arabic/section5.png"
                />

                <YellowCTAhref
                    text2="لا يتطلب بطاقة ائتمان. ابدأ بشكل مجاني."
                    buttonText=" لا يتطلب بطاقة ائتمان. ابدأ بشكل مجاني."
                    customText=" أطلق العنان للإمكانات الكاملة لأداة واتساب الخاصة بنا من خلال خيارات التسعير المرنة لدينا"
                />

                <section className="pt-10">
                    <GallaboxBadgesGray ArabicText="المستهلكون يحبونا" />
                </section>
                <div className="mx-auto " style={{ maxWidth: "1440px" }}>
                    <ArabicTestimonialSection />
                </div>
                <ImageGrid
                    buttonTxt="البدء"
                    href="https://app.gallabox.com/signup"
                    title="التكامل"
                    description="توصيل الكومبيوتر مع جالابوكس بسهولة"
                    content="هل لديك مجموعة برامج متنوعة؟ لا مشكلة! ستتماشى جالابوكس بشكل مثالي من خلال التكامل السلس مع البرمجيات الحالية لديك، سواء كانت نظم إدارة العلاقات مع العملاء أو معالجي الدفع."
                />

                <section className="relative" style={{ background: "#002055" }}>
                    <div className="max-w-6xl mx-auto py-20 px-4 flex flex-col items-center">
                        <h4 className="p-0 m-0 tracking-wider text-base uppercase font-bold text-center text-caribbean-green">شاهد الفيديو</h4>
                        <h3 className="p-0 m-0 text-2xl lg:text-3xl font-medium text-center max-w-screen-md leading-snug tracking-wide text-white mt-2">
                            Gallabox تعرف على المزيد عن
                        </h3>
                        <div className="track_videoplay wistia_responsive_padding rounded-xl z-1 mt-10 w-full max-w-screen-md relative" style={{ padding: "46.25% 0 0 0" }}>
                            <div className="wistia_responsive_wrapper h-full w-full absolute top-0 left-0">
                                <div className="wistia_embed wistia_async_730lmkyzty videoFoam=true" style={{ height: "100%", position: "relative", width: "100%" }}>
                                    <div
                                        className={`${Addclassforvideo && "videoopacity"} wistia_swatch`}
                                        style={{
                                            height: "100%",
                                            left: "0",
                                            opacity: "0",
                                            overflow: "hidden",
                                            position: "absolute",
                                            top: "0",
                                            transition: "opacity 200ms",
                                            width: "100%",
                                        }}
                                    >
                                        <img
                                            src="https://fast.wistia.com/embed/medias/730lmkyzty/swatch"
                                            style={{ filter: "blur(5px)", height: "100%", objectFit: "contain", width: "100%" }}
                                            alt=""
                                            aria-hidden="true"
                                            onLoad={() => setAddclassforvideo(true)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img alt="" className="absolute top-0 left-0 right-0 bottom-0 w-full" src="https://assets.gallabox.com/gb-home/home/wave-bg.webp" />
                </section>
                <YellowCTAhref
                    text2="لا يتطلب بطاقة ائتمان. ابدأ بشكل مجاني."
                    buttonText="لا يتطلب بطاقة ائتمان. ابدأ بشكل مجاني."
                    customText=" أطلق العنان للإمكانات الكاملة لأداة واتساب الخاصة بنا من خلال خيارات التسعير المرنة لدينا"
                />
            </section>
            {modalHeader && <Modal onClose={handleClose} modalHeader={modalHeader} ctaLabel={modalHeader} subjectSuffix={` [${modalHeader}]`} />}
        </NewLayout>
    );
};

export default Home;
